/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SizeQueryValue
 */
export interface SizeQueryValue {
    /**
     * 
     * @type {number}
     * @memberof SizeQueryValue
     */
    gt?: number;
    /**
     * 
     * @type {number}
     * @memberof SizeQueryValue
     */
    gte?: number;
    /**
     * 
     * @type {number}
     * @memberof SizeQueryValue
     */
    lt?: number;
    /**
     * 
     * @type {number}
     * @memberof SizeQueryValue
     */
    lte?: number;
}

/**
 * Check if a given object implements the SizeQueryValue interface.
 */
export function instanceOfSizeQueryValue(value: object): value is SizeQueryValue {
    return true;
}

export function SizeQueryValueFromJSON(json: any): SizeQueryValue {
    return SizeQueryValueFromJSONTyped(json, false);
}

export function SizeQueryValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): SizeQueryValue {
    if (json == null) {
        return json;
    }
    return {
        
        'gt': json['gt'] == null ? undefined : json['gt'],
        'gte': json['gte'] == null ? undefined : json['gte'],
        'lt': json['lt'] == null ? undefined : json['lt'],
        'lte': json['lte'] == null ? undefined : json['lte'],
    };
}

export function SizeQueryValueToJSON(json: any): SizeQueryValue {
    return SizeQueryValueToJSONTyped(json, false);
}

export function SizeQueryValueToJSONTyped(value?: SizeQueryValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gt': value['gt'],
        'gte': value['gte'],
        'lt': value['lt'],
        'lte': value['lte'],
    };
}

